import { QarepaEnumInformation } from '@qarepa/common';

export enum CheckCategoryEnum {
  WORK = 'WORK',
  BREAK = 'BREAK',
}

export const CheckCategoryArray: CheckCategoryEnum[] = [
  CheckCategoryEnum.WORK,
  CheckCategoryEnum.BREAK,
];

export const CheckCategoryInfo: QarepaEnumInformation<CheckCategoryEnum> = {
  [CheckCategoryEnum.WORK]: {
    name: $localize`Trabajo`,
  },
  [CheckCategoryEnum.BREAK]: {
    name: $localize`Descanso`,
  },
};
